import { IndexSort } from "@omni/types/api/search/algolia/shared/enum/indexSort.enum";

import { Facet } from "@/components/Search/SearchResults/components/results/components/productsResults/components/facets/components/facet/@types/facet.types";
import { FacetType } from "@/components/Search/SearchResults/components/results/components/productsResults/components/facets/components/facet/@types/facetType.types";
import { DefaultHitsPerPage } from "@/components/Search/SearchResults/components/results/components/productsResults/components/resultsView/components/filters/components/productHitsPerPage/hitsPerPage.config";
import { AnySearchConfiguration } from "@/utils/search/types/searchConfiguration";

export const PREFIX_SEPARATOR = ".";
export const NUMERIC_FILTER_SEPARATOR = ":";
export const FACET_FILTER_SEPARATOR = ";";

// We only allow specific non-searchable facets to be included in the URL
// so clients cannot query using arbitrary facets
export const ALLOWED_NON_SEARCHABLE_FACETS: Array<
    Pick<Facet<FacetType>, "name" | "type">
> = [
    {
        name: "productIdentifiers",
        type: FacetType.DEFAULT
    }
];

// Configuration -> Route
export const DEFAULT_ROUTE: AnySearchConfiguration = {
    hitsPerPage: DefaultHitsPerPage,
    page: 0,
    sortBy: IndexSort.Default
};

// Route -> Configuration
export const NUMERIC_FILTER_REGEX = new RegExp(
    `(\\d+|\\*)${NUMERIC_FILTER_SEPARATOR}(\\d+|\\*)`
);
